import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { checkOrgSuccess, checkOrgFailed } from '../actions';
import { OrganizationTypes } from '../types';
import {
  getAuthOrganisationId,
  isAuthOrganisationMismatch,
  setOrgRoutingKeys,
} from 'utils/portalSlug';
import { errorNotifier, logout } from 'utils/helpers';

const { API_BASE_URL } = urls || {};

export function* checkOrgExistence({ data: { id, cb } }) {
  const url = `${API_BASE_URL}/portals/${encodeURIComponent(id)}/organisation`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success && response.statusCode === 200) {
    const org = response.raw || {};
    const canonicalId = org.id || '';
    const portalAlias = org.portalAlias || canonicalId;
    const payload = {
      id: canonicalId,
      portalAlias,
      name: org.name,
      logoUrl: org.logoUrl,
      courseAlias: org.courseAlias,
    };
    if (getAuthOrganisationId() && canonicalId && isAuthOrganisationMismatch(canonicalId)) {
      errorNotifier(
        'You are signed in to a different organisation. Please sign in again for this portal.'
      );
      logout();
      return;
    }
    setOrgRoutingKeys(canonicalId, portalAlias);
    if (cb) {
      cb(payload);
    }
    yield put(checkOrgSuccess(payload));
    return;
  }
  if (response.statusCode === 404) yield put(checkOrgFailed());
}

export function* orgCheck() {
  yield takeEvery(OrganizationTypes.CHECK_ORG_EXISTS, checkOrgExistence);
}
